import styled from 'styled-components';
import theme from '../theme';

export const PageWrapper = styled.div`
  font-family: ${theme.typography.fontFamily};
`;

export const PageHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing.xl};
`;

export const PageTitle = styled.h1`
  font-size: ${theme.typography.h1.size};
  font-weight: ${theme.typography.h1.weight};
  color: ${theme.colors.text};
  margin: 0 0 ${theme.spacing.sm};

  ${theme.media.mobile} {
    font-size: ${theme.typography.h2.size};
  }
`;

export const PageSubtitle = styled.p`
  font-size: ${theme.typography.body.size};
  color: ${theme.colors.textSecondary};
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
`;

export const SectionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${theme.spacing.lg};

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionCard = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${theme.radii.md};
  box-shadow: ${theme.shadows.sm};
  padding: ${theme.spacing.lg};
  cursor: pointer;
  transition: all ${theme.transitions.normal};
  border-left: 4px solid ${({ $accent }) => $accent || theme.colors.primary};
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: ${theme.shadows.md};
    transform: translateY(-2px);
  }
`;

export const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: ${theme.radii.sm};
  background: ${({ $bg }) => $bg || theme.colors.primaryGhost};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-bottom: ${theme.spacing.md};
  flex-shrink: 0;
`;

export const SectionTitle = styled.h3`
  font-size: ${theme.typography.h3.size};
  font-weight: ${theme.typography.h3.weight};
  color: ${theme.colors.text};
  margin: 0 0 ${theme.spacing.sm};
`;

export const SectionDescription = styled.p`
  font-size: ${theme.typography.small.size};
  color: ${theme.colors.textSecondary};
  margin: 0;
  line-height: 1.6;
  flex: 1;
`;

export const SectionArrow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing.xs};
  color: ${theme.colors.primary};
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  margin-top: ${theme.spacing.md};
`;
